import React from "react";
import "./pofileComplitionBar.scss";
import useTheme from "../../../components/useTheme/useTheme";
const ProfileComplitionBar = ({ percentage }) => {
  const { theme } = useTheme();
  return (
    <div className={`profile-completion-container ${theme === "dark" && "profile-completion-container--dark-mode"}`}>
      <span className="label">Profile Completion :</span>
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      <span className="percentage">{percentage}%</span>
    </div>
  );
};

export default ProfileComplitionBar;
